import React, { useCallback } from 'react';
import {
  NovuProvider,
  PopoverNotificationCenter,
  NotificationBell,
  IMessage,
} from '@novu/notification-center';
import { useSelector } from 'react-redux';
import { FiBell } from 'react-icons/fi';
import Button from 'components/Button';
import { NOVU_ID } from 'config/environment';

interface Props {
  theme: 'light' | 'dark';
}

const Novu: React.FC<Props> = ({ theme }: Props) => {
  const { profile } = useSelector((state: any) => state.usuario);
  const onNotificationClick = useCallback((message: IMessage) => {
    if (message?.cta?.data?.url) {
      window.location.href = message.cta.data.url;
    }
  }, []);
  return profile && NOVU_ID ? (
    <NovuProvider subscriberId={profile.login} applicationIdentifier={NOVU_ID}>
      <PopoverNotificationCenter
        onNotificationClick={onNotificationClick}
        colorScheme={theme}
      >
        {({ unseenCount }) => <NotificationBell unseenCount={unseenCount} />}
      </PopoverNotificationCenter>
    </NovuProvider>
  ) : (
    <Button fill round color="font" disabled>
      <FiBell />
    </Button>
  );
};

export default Novu;
